// extracted by mini-css-extract-plugin
export default {"accordionsDiv":"Accordions_accordionsDiv__k4-oO"};